import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AccOfferedSeatCountsPart } from '../../../acc-offered-seat-counts/acc-offered-seat-counts.part';


@Component({
	selector: 'admissions-accelerators-tab-1-part',
	standalone: true,
	imports: [AccOfferedSeatCountsPart],
	templateUrl: './admissions-accelerators-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-accelerators-tab-1.part.scss`],
})
export class AdmissionsAcceleratorsTab1Part {
}
